<template>
    <div class="body">
        <MenuPage></MenuPage>
        <Dialog v-model:visible="spinnervisible" modal :closable="false" class="alrt">
            <div>
                <ProgressSpinner style="width: 50px; height: 50px; display: block; margin: auto;" strokeWidth="8"
                    fill="transparent" animationDuration=".5s" aria-label="Custom ProgressSpinner" />

                <p>{{ texto }}</p>
            </div>
        </Dialog>

        <Dialog v-model:visible="adjuntar" modal header="Adjunta Factura">
            <FileUpload name="demo[]" :custom-upload="true" @uploader="CrearOdenCliente($event)" :multiple="false"
                :maxFileSize="100000000">
                <template #empty>
                    <span>Arrastra los archivos aqui para subirlos.</span>
                </template>
            </FileUpload>
        </Dialog>


        <Dialog v-model:visible="mostrarhistorial" modal class="modal_info">
            <p style="font-size: 14px; font-weight:bold;">Historial de movimientos</p>
            <p style="font-size: 12px;">Entrada a almacen indeasa</p>
            <p style="font-size: 12px;"><b>Fecha: </b>{{ MostrarMovimientos.fecha_entrada }}</p>
            <p style="font-size: 12px;"><b>Orden: </b>{{ MostrarMovimientos.numero_orden_1 }}</p>
            <hr>
            <p style="font-size: 12px;">Entrada a almacen apizaco</p>
            <p style="font-size: 12px;"><b>Fecha: </b>{{ MostrarMovimientos.fecha_apizaco }}</p>
            <p style="font-size: 12px;"><b>Orden: </b>{{ MostrarMovimientos.numero_orden_2 }}</p>
            <p style="font-size: 12px;"><b>usuario: </b>{{ MostrarMovimientos.usuario_crea_apizaco }}</p>
            <p style="font-size: 12px;" v-if="MostrarMovimientos.numero_orden_2 !== null"><b>porcentaje que ingresa:
                </b>{{
                    MostrarMovimientos.porcentaje_entrada_apizaco }}%</p>
            <hr>
            <p style="font-size: 12px;">Llendo</p>
            <p style="font-size: 12px;"><b>Fecha: </b>{{ MostrarMovimientos.fecha_llenado }}</p>
            <p style="font-size: 12px;"><b>usuario: </b>{{ MostrarMovimientos.usuario_llena }}</p>
            <hr>
            <p style="font-size: 12px;">Salida a Almacen</p>
            <p style="font-size: 12px;"><b>Fecha: </b>{{ MostrarMovimientos.fecha_retorno }}</p>
            <p style="font-size: 12px;"><b>Orden: </b>{{ MostrarMovimientos.numero_orden_3 }}</p>
            <p style="font-size: 12px;"><b>usuario: </b>{{ MostrarMovimientos.usuario_retorna }}</p>
            <p style="font-size: 12px;" v-if="MostrarMovimientos.numero_orden_3 !== null"><b>Porcentaje que sale: </b>{{
                MostrarMovimientos.porcentaje_salida }}%</p>
        </Dialog>


        <div class="content">
            <DataTable :value="almacenes" dataKey="Id" paginator :rows="10" scrollable scrollHeight="60vh"
                :filters="filters" filterDisplay="row" :globalFilterFields="['Numero_unico', 'producto']">
                <template #header>
                    <div class="table-header flex gap-2">
                        <div class="container">
                            <div class="row">
                                <div class="col-md-2">
                                    <h3>Almacen Indeasa</h3>
                                </div>
                                <div class="col-md-6">
                                    <div class="container">
                                        <div class="row">
                                            <div class="col-md-4">
                                                <p class="text-12">Ver completos</p>
                                                <ToggleSwitch v-model="checked" @change="elegirdatos()" />

                                            </div>
                                            <div class="col-md-8">
                                                <Calendar v-model="fecha" selectionMode="range" dateFormat="yy-mm-dd"
                                                    showIcon placeholder="Filtrar por rango" style="margin-top: 15px;"
                                                    v-show="checked" @update:modelValue="getitemsComplete" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <Button label="Entrada a Planta apizaco" style="margin-top: 12px;" icon="pi pi-plus"
                                        class="p-button-info" @click="PasarLlenado"
                                        v-if="puntos.length !== 0 & statusgen === 'vacio'" />
                                    <Button label="Mandar a cliente" icon="pi pi-external-link" class="p-button-info"
                                        @click="MostrarModal"
                                        v-if="puntos.length !== 0 & (statusgen === 'transito' || statusgen === 'lleno')" />

                                </div>
                            </div>
                        </div>
                    </div>
                </template>


                <Column headerStyle="width:3rem">
                    <template #body="{ data }">
                        <Checkbox @change="Checkstatus(`${data.Estatus}`)" v-model="puntos" :value="data" />
                    </template>
                </Column>




                <Column field="Numero_unico" header="Número único" style="min-width:12rem" :filter="true"
                    :showFilterMenu="false">
                    <!-- Campo de filtro -->
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText v-model="filterModel.value" type="text" @input="filterCallback()"
                            placeholder="Buscar número" />
                    </template>

                    <!-- Contenido de la celda -->
                    <template #body="{ data }">
                        <div class="item-number" v-tooltip.bottom="'Ver movimientos'"
                            @click="MostrarMovimientosItem(data)">
                            {{ data.Numero_unico }}
                        </div>
                    </template>
                </Column>

                <Column field="orden" header="Orden" style="min-width:12rem">
                    <template #body="{ data }">
                        <div class="order-number">
                            {{ data.orden }}
                        </div>

                    </template>
                </Column>

                <Column field="producto" header="Producto" style="min-width:12rem">
                    <template #body="{ data }">
                        {{ data.producto }}
                    </template>
                </Column>

                <Column field="cliente" header="Cliente" style="min-width:12rem">
                    <template #body="{ data }">
                        {{ data.cliente }}
                    </template>
                </Column>

                <Column field="Estatus" header="Estatus" style="min-width:12rem">
                    <template #body="{ data }">
                        <div class="customfilter bg_admin" v-if="data.Estatus === 'vacio'">
                            {{ data.Estatus }}
                        </div>
                        <div class="customfilter bg_operador"
                            v-if="data.Estatus === 'transito' || data.Estatus === 'lleno'">
                            lleno
                        </div>
                        <div class="customfilter bg_facturacion" v-if="data.Estatus === 'completo'">
                            {{ data.Estatus }}
                        </div>
                    </template>
                </Column>
            </DataTable>

        </div>
    </div>
</template>


<script setup>
import api from '@/plugins/axios';
import MenuPage from '../MenuPage.vue';
import InputText from 'primevue/inputtext';
import { onMounted, ref } from 'vue';
// import FloatLabel from 'primevue/floatlabel';
import { Dialog, Column, Calendar, DataTable, ToggleSwitch, Button, ProgressSpinner, Checkbox, FileUpload } from 'primevue';
// import { useToast } from 'vue-toastification';
import { nextTick } from 'vue';
import { useToast } from 'vue-toastification';
import { PDFDocument } from "pdf-lib";

const puntos = ref([]);

const filters = ref({
    global: { value: null },
    Numero_unico: { value: null, matchMode: 'contains' }
});
const fecha = ref([new Date(), new Date()]);

const checked = ref(false)
const almacenes = ref([]);
const spinnervisible = ref(true);
const toast = useToast();
const statusgen = ref("");
const error = ref("");
const adjuntar = ref(false);
const MostrarMovimientos = ref([]);
const mostrarhistorial = ref(false);
const texto = ref("Cragando inventario");



const getItems = async () => {
    try {
        const res = await api.get("/almacen/getalmacen/indeasa");
        almacenes.value = res.data ?? [];
        nextTick(() => {
            spinnervisible.value = false;
        });
    }
    catch (err) {
        console.error(err);
    }
}

const getitemsComplete = async () => {
    try {
        spinnervisible.value = true;
        const res = await api.post("/almacen/gethistorial", {
            fecha_inicio: formatDateToMySQL(fecha.value[0]),
            fecha_fin: formatDateToMySQL(fecha.value[1])
        });
        if (checked.value) {
            almacenes.value = res.data;
        }
        nextTick(() => {
            spinnervisible.value = false;
        });
    }
    catch (err) {
        console.error(err);
    }
}

const elegirdatos = () => {
    if (checked.value) {
        getitemsComplete();
    }
    else {
        getItems();
    }
}

const formatDateToMySQL = (date) => {
    const d = new Date(date);

    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0"); // meses 0-11
    const day = String(d.getDate()).padStart(2, "0");
    const hours = String(d.getHours()).padStart(2, "0");
    const minutes = String(d.getMinutes()).padStart(2, "0");
    const seconds = String(d.getSeconds()).padStart(2, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

const PasarLlenado = async () => {
    try {
        texto.value = "Pasando a llenado";
        spinnervisible.value = true;
        if (error.value !== "error") {
            const res = await api.post("/almacen/pasarllenado", {
                items: JSON.stringify(puntos.value),
                user: localStorage.getItem("nombre")
            });
            if (res.data.response === 'success') {
                await getItems();
                toast.success("Items pasados a la planta de lleado con exito");
                spinnervisible.value = false;
            }
        }
        else {
            toast.error("No puedes mandar items a llenado ya llenos");
            spinnervisible.value = false;
        }
    }
    catch (err) {
        console.error(err);
        spinnervisible.value = false;
    }
}

const Checkstatus = (estatus) => {
    error.value = "";
    if (statusgen.value == "") {
        statusgen.value = estatus;
        return;
    }
    else if (puntos.value.length === 0) {
        statusgen.value = "";
        return true;
    }

    if (statusgen.value === estatus) {
        return true;
    }
    else {
        toast.error("Selecciona items con estatus iguales");
        error.value = "error";
        statusgen.value = "";
        puntos.value = [];
        return false;
    }
}

const MostrarModal = () => {
    adjuntar.value = true;
}

const CrearOdenCliente = async (event) => {
    const archivo = event.files[0];
    console.log(archivo);
    const archivoConvertido = await procesarArchivo(archivo);
    setTimeout(async () => {
        try {
            let form = new FormData();
            form.append("evidencia", archivoConvertido);
            form.append("items", JSON.stringify(puntos.value));
            form.append("user", localStorage.getItem("nombre"));
            const res = await api.post("/almacen/pasarcliente", form);
            if (res.data.response === 'success') {
                toast.success("Orden de servicio pasada a cliente");
                adjuntar.value = false;
                await getItems();
                statusgen.value = "";
            }
        }
        catch (err) {
            console.error(err);
        }
    }, 1000);

};


//Verificar el tipo de archivo
const procesarArchivo = async (file) => {
    const type = file.type;

    //   SI ES IMAGEN
    if (type.startsWith("image/")) {
        return await procesarImagen(file, 1200, 0.8); // convertir a webp
    }

    //   SI ES PDF
    if (type === "application/pdf") {
        return await comprimirPDF(file);
    }

    // Si no es imagen ni PDF, regresamos el archivo original
    return file;
};

//Procesado de imagenes

const procesarImagen = (file, maxWidth = 1200, calidad = 0.8) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onload = (e) => {
            const img = new Image();
            img.src = e.target.result;

            img.onload = () => {
                const canvas = document.createElement("canvas");

                // Redimensionar manteniendo proporción
                let width = img.width;
                let height = img.height;

                if (width > maxWidth) {
                    height *= maxWidth / width;
                    width = maxWidth;
                }

                canvas.width = width;
                canvas.height = height;

                const ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0, width, height);

                canvas.toBlob(
                    (blob) => {
                        if (!blob) {
                            reject("Error al generar WebP");
                            return;
                        }

                        // Regresar un FILE listo para subir
                        const webpFile = new File(
                            [blob],
                            file.name.replace(/\.\w+$/, ".webp"),
                            { type: "image/webp" }
                        );

                        resolve(webpFile);
                    },
                    "image/webp",
                    calidad
                );
            };

            img.onerror = reject;
        };
    });
};


//Comprimir PDF
const comprimirPDF = async (file) => {
    const arrayBuffer = await file.arrayBuffer();

    // Cargar PDF
    const pdfDoc = await PDFDocument.load(arrayBuffer, {
        updateMetadata: false,
        ignoreEncryption: true,
    });

    // Quitar metadatos extras
    pdfDoc.setProducer("");
    pdfDoc.setCreator("");
    pdfDoc.setTitle("");
    pdfDoc.setSubject("");
    pdfDoc.setKeywords([]);

    // Guardar PDF optimizado
    const pdfBytes = await pdfDoc.save({
        useObjectStreams: true,
        addDefaultPage: false,
    });

    return new File(
        [pdfBytes],
        file.name.replace(".pdf", "_compressed.pdf"),
        { type: "application/pdf" }
    );
};

const MostrarMovimientosItem = async (data) => {
    try {
        const res = await api.post("/almacen/mostrarmovimientoitem", {
            id: data.Id
        });
        MostrarMovimientos.value = res.data;
        mostrarhistorial.value = true;
    }
    catch (err) {
        console.error(err);
    }
}

onMounted(async () => {
    await getItems();
    await getitemsComplete();
});



</script>


<style scoped>
.modal_info {
    width: 50%;
}

.customfilter {
    width: 100px;
    border-radius: 5px;
    text-align: center;
    padding: 2px;
}

.bg_admin {
    background: rgba(0, 136, 255, 0.362);
    color: rgb(0, 140, 255);
}

.bg_facturacion {
    background: rgb(255, 183, 0);
    color: rgb(255, 255, 255);
}

.bg_operador {
    background: rgba(0, 196, 49, 0.362);
    color: rgb(17, 114, 0);
}

.order-number {
    width: 90%;
    background: rgb(0, 92, 192);
    color: white;
    text-align: center;
    cursor: pointer;
    font-size: 12px;
    border: 1px solid rgb(0, 92, 192);
    border-radius: 12px;
    box-shadow: 0px 2px 4px rgb(211, 211, 211);
    padding: 10px;
}

.item-number {
    width: 90%;
    background: rgb(0, 199, 99);
    color: white;
    text-align: center;
    cursor: pointer;
    border: 1px solid rgb(0, 199, 99);
    border-radius: 12px;
    box-shadow: 0px 2px 4px rgb(211, 211, 211);
    padding: 10px;
}

@media(max-width:990px) {
    .modal_info {
        width: 95%;
    }
}
</style>